import React from 'react';

import SelectMUI from '../../atoms/Forms/Select';
import HotelGuestDropdown from '../../atoms/HotelGuestDropdown';
import useStyles from './HotelGuestWidget.style';

const getKey = updateWidgetData => {
  let keyToMatch = '';
  updateWidgetData.map(data => {
    keyToMatch = data.fields.key.value;
    return data;
  });

  return keyToMatch;
};

const HotelGuestWidget = props => {
  const classes = useStyles();
  const { widgetData, widget } = props;
  const { selectedValue } = props.data;
  const keyToMatch = getKey(widgetData);
  const shouldShowWidget = selectedValue.value === keyToMatch;

  shouldShowWidget
    ? props.setWidgetDataValue(true)
    : props.setWidgetDataValue(false);
  return (
    <div className={classes.root}>
      <SelectMUI data={props.data} onChange={props.onChange} />
      {shouldShowWidget && (
        <HotelGuestDropdown
          widgetData={widgetData}
          widget={widget}
          onWidgetDataChange={props.onWidgetDataChange}
          onRemoveClick={props.onRemoveClick}
          addToWidgetPayload={props.addToWidgetPayload}
          onAddRoomClick={props.onAddRoomClick}
        />
      )}
    </div>
  );
};

export default HotelGuestWidget;
